export default __webpack_public_path__ + "static/media/ag-icon.0fe39382.webp";